import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { AuthService } from "../auth.service";

@Injectable()
export class RequestInterceptor implements HttpInterceptor {

    private matcher = new Map<string, string>()
        .set('/file/api/v2/download', 'GET');


    constructor(
        private authService: AuthService,
    ) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let token = this.authService.getAuthFromLocalStorage()?.accessToken?.value;
        if (this.isValidUrl(req.url) && token && this.match(req)) {
            req = req.clone({
                setHeaders: {
                    Authorization: `${token}`,
                    AccessControlAllowOrigin: '*',
                },
            });
        }

        return next.handle(req)
            .pipe(catchError(err => {
                let error = err.error?.message || err.error?.error || err.statusText || err.message;
                if (error === "jwt expired") {
                    // auto logout if 401 response returned from api
                    this.authService.logout();
                    return throwError(error);
                } else if (err.status === 401) {
                    // this.genSer.sweetAlertInfo(error, 'Session');
                    this.authService.logout();
                    // return throwError({ message: "Your license request is pending approval, kindly try again later." });
                }
                return throwError(err);
            }))
    }

    isValidUrl(url: string) {
        return url.includes('localhost') || url.includes('https://fluxvend.com') || url.includes('fluxvend');
    }

    match(req: HttpRequest<any>): boolean {
        const method = req.method;
        const path = req.url;
        for (const [key, value] of this.matcher.entries()) {
            if ((path == "*" || path.includes(key)) && (method == "*" || method === value)) {
                return true;
            }
        }
        return false;
    }
}

